import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatSlideToggle} from '@angular/material/slide-toggle';

@Component({
  selector: 'app-switchtheme',
  templateUrl: './switchtheme.component.html',
  styleUrls: ['./switchtheme.component.scss']
})
export class SwitchthemeComponent implements OnInit {

  @ViewChild("lightDarkToggle") ref: MatSlideToggle;
  checked:boolean;
  ngOnInit(): void {
  }
  private darkThemeIcon = 'nightlight_round';
  private lightThemeIcon = 'wb_sunny';
  public lightDarkToggleIcon = this.lightThemeIcon;
  public defaultTheme = true;
  @Output() darkThemeOn: EventEmitter<boolean> = new EventEmitter<boolean>();


  constructor() {
    this.checkDefaultTheme();
  }

  /**
   * Check in localStorage if user chose dark-theme previously
   * If so, initiate the app with the dark-theme (non default)
   * @private
   */
  private checkDefaultTheme() {
    // Dark is the default theme; only an explicit 'light' selection turns it off.
    if (localStorage.getItem('theme') === 'light') {
      this.lightDarkToggleIcon = this.lightThemeIcon;
      this.defaultTheme = true;
      this.checked = false;
    } else {
      this.lightDarkToggleIcon = this.darkThemeIcon;
      this.defaultTheme = false;
      this.checked = true;
    }
  }

  /**
   * Change theme switcher icon to show the icon of the inactive theme (if light theme is on, the icon of dark theme is displayed)
   * Emit value to parent component to adapt theme and styling
   * If defaultTheme:
   * Default position of toggle is "checked" (true) which corresponds to displaying the light theme
   * When toggle position is false, the dark theme must be displayed
   * If !defaultTheme:
   * Behavior is the other way around
   * @param toggle The toggle object from the template
   */
  public doToggleLightDark(e) {
    if (this.defaultTheme) {
      this.lightDarkToggleIcon = !e.checked ? this.lightThemeIcon : this.darkThemeIcon;
      this.darkThemeOn.emit(e.checked);
    } else {
      this.lightDarkToggleIcon = !e.checked ? this.lightThemeIcon : this.darkThemeIcon;
      this.darkThemeOn.emit(e.checked);
    }
  }

}
